/* eslint-disable no-undef, no-unused-vars, import/first */

require('./bootstrap');
require('./store/event-mapper');

import Loading from 'vue-loading-overlay';
import Password from 'vue-password-strength-meter';
import Buefy from 'buefy';

import CertificateSample from './components/Shop/CertificateSample';
import Registration from './components/User/Registration';
import TermsAndConditions from './components/User/TermsAndConditions';
import CookieConsent from './components/User/CookieConsent';
import SubscriptionBonusPopup from './components/Newsletters/SubscriptionBonusPopup';
import NewsletterConsent from './components/User/NewsletterConsent';
import CountrySelect from './components/Countries/Select';
import DateInput from './components/DatePicker/Input';
import Subscribe from './components/Newsletters/Subscribe';
import AnnouncementMessage from './components/Html/common/AnnouncementMessage';
import Multiselect from './components/Html/common/Multiselect';
import FAQ from './components/FAQ';
import InitialsImg from './components/InitialsImg';
import ProductCard from './components/Shop/ProductCard';
import AddToCartButton from './components/Shop/AddToCartButton';
import AddToCartFromProductCombinations from './components/Shop/AddToCartFromProductCombinations';

import QuickShare from './components/Course/QuickShare';
import PendingShares from './components/Course/PendingShares';
import Sharing from './components/Course/Sharing';
import AvailabilityList from './components/Course/AvailabilityList';
import EmployeeGroup from './components/Employees/Group/Edit';
import OrganizeNewCourse from './components/Course/Organize/Index';
import Exam from './components/Course/Chapters/Examination/Index';
import ExamResults from './components/Course/Chapters/Examination/ExamResults';
import Progress from './components/Course/Progress';
import DemoVideo from './components/Video/Demo';
import IndexSlides from './components/Views/IndexSlides';
import ClientsLogo from './components/Views/ClientsLogo';
import BillingInformation from './components/User/BillingInformation';
import AddedToCartModal from './components/Shop/AddedToCartModal';
import ProductSearchInput from './components/Shop/ProductSearchInput';
import CancelOrder from './components/Order/CancelOrder';
import SyllabusChaptersTree from './components/SyllabusChapters/SyllabusChaptersTree';
import QuestionsAndAnswers from './components/Course/QuestionsAndAnswers';
import InvitationsList from './components/Employees/Invitations/InvitationsList';
import PendingInvitationsPopup from './components/Employees/Invitations/PendingInvitationsPopup';
import ClassroomTrainingContactUsForm from './components/ClassroomTraining/ClassroomTrainingContactUsForm';

Vue.use(Loading);

Vue.component('Loading', Loading);
Vue.use(Buefy, { defaultIconPack: 'fa' });
Vue.component('Password', Password);

Vue.component('initials-img', InitialsImg);
Vue.component('multiselect', Multiselect);
Vue.component('registration', Registration);
Vue.component('terms-and-conditions', TermsAndConditions);
Vue.component('cookie-consent', CookieConsent);
Vue.component('subscription-bonus-popup', SubscriptionBonusPopup);
Vue.component('added-to-cart-modal', AddedToCartModal);
Vue.component('newsletter-consent', NewsletterConsent);
Vue.component('country-select', CountrySelect);
Vue.component('date-input', DateInput);
Vue.component('subscribe', Subscribe);
Vue.component('faq', FAQ);
Vue.component('announcement-message', AnnouncementMessage);
Vue.component('product-search-input', ProductSearchInput);

// Views
Vue.component('index-slides', IndexSlides);
Vue.component('clients-logo', ClientsLogo);

// Cart/Products
Vue.component('product-card', ProductCard);
Vue.component('add-to-cart-button', AddToCartButton);
Vue.component('add-to-cart-from-product-combinations', AddToCartFromProductCombinations);
Vue.component('demo-video', DemoVideo);
Vue.component('billing-information', BillingInformation);
Vue.component('certificate-sample', CertificateSample);
Vue.component('syllabus-chapters-tree', SyllabusChaptersTree);

// Course
Vue.component('quick-share', QuickShare);
Vue.component('sharing', Sharing);
Vue.component('pending-shares', PendingShares);
Vue.component('availability-list', AvailabilityList);
Vue.component('organize-new-course', OrganizeNewCourse);
Vue.component('course-progress', Progress);
Vue.component('questions-and-answers', QuestionsAndAnswers);

// Employees
Vue.component('employee-group', EmployeeGroup);
Vue.component('invitations-list', InvitationsList);
Vue.component('pending-invitations-popup', PendingInvitationsPopup);

Vue.component('exam', Exam);
Vue.component('exam-results', ExamResults);

// Order
Vue.component('cancel-order', CancelOrder);

// Classroom training
Vue.component('classroom-training-contact-us-form', ClassroomTrainingContactUsForm);
